import axios from "axios";
import config from "./config";

const uploadDirectoryToS3 = async (data, key) => {
  const indexData = JSON.stringify(data);

  let newKey = "";

  switch (key) {
    case "pressReleases":
      newKey = "media/press-release/index.json";
      break;
    case "careers":
      newKey = "careers/index.json";
      break;
    case "images":
      newKey = "media/images/index.json";
      break;
    case "headshotsAndLogos":
      newKey = "media/headshotsAndLogos/index.json";
      break;
    case "videos":
      newKey = "media/videos/index.json";
      break;
    case "articles":
      newKey = "media/articles/index.json";
      break;

    default:
      break;
  }

  const args = {
    Body: indexData,
    Key: newKey,
    ContentType: "application/json",
  };

  const [url, params] = await config("putObject", args);

  return await axios.post(url, params);
};

export default uploadDirectoryToS3;
